<template>
	<ValidationProvider :name="idLabel" :rules="{ required: required, addressFieldsPopulated: true }" :immediate="immediate" v-slot="{ failed }" slim>
		<div :class="{ 'form-group': true, visited: value || focused, 'is-invalid-wrapper': failed }">
			<label :for="$id('address-finder-input')" class="col-form-label form-control-placeholder">
				{{ label }}
				<span class="required" v-if="required">*</span>
			</label>
			<input
				type="search"
				:class="{ 'form-control': true, 'is-invalid': failed }"
				:name="$id('address-finder-input')"
				:id="$id('address-finder-input')"
				:value="value"
				@input="$emit('input', $event.target.value)"
				ref="addressfinder"
				autocomplete="disable-autocomplete"
				@focus="handleFocus"
				@blur="handleBlur"
			/>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import Swal from 'sweetalert2';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import '../Utils/validation';

export default {
	mixins: [formControlProps, validationProps],

	props: {
		addressFieldsMissing: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			focused: false,
			selected: false
		};
	},

	mounted() {

		// Extend validation to fail if address fields are missing while field is required and not focused
		extend('addressFieldsPopulated', {
			validate: () => {
				return !(this.required && !this.focused && this.addressFieldsMissing);
			},
			message: '{_field_} is missing address data',
		});

		// Create AddressFinder script
		let script = document.createElement('script');
		script.setAttribute('src', 'https://api.addressfinder.io/assets/v3/widget.js');
		script.setAttribute('async', true);

		// Register onload event
		script.onload = () => {
			this.widget = new window.AddressFinder.Widget(this.$refs.addressfinder, 'RTG6AY9KHUQX84EWVD3J', 'NZ', {
				address_params: {
					delivered: '1',
				},
			});

			this.widget
				.on('address:select:pre', () => {
					this.selected = true;
				})
				.on('result:select', (fullAddress, metaData) => {
					// Ensure value is updated to the full address within binding
					this.$emit('input', fullAddress);

					// Get AddressFinder object from address data and fire our selected event with it
					/* eslint-disable no-undef */
					const selectedAddress = new AddressFinder.NZSelectedAddress(fullAddress, metaData);

					this.$emit('selected', selectedAddress);
				});
		};

		// Add to DOM
		document.head.appendChild(script);
	},

	methods: {
		handleFocus() {
			this.focused = true;
		},

		handleBlur() {
			this.focused = false;

			// Alert no address was selected if bluring and no selection was made and field is still required
			window.setTimeout(() => {
				if (this.required && !this.selected) {
					Swal.fire(
						'Address Not Found',
						'We\'re unable to find your address. Please select an option from the suggestions that appear while typing, or follow the prompt to enter it manually.',
						'warning'
					);
				}
			}, 200);
		}
	},

	components: {
		ValidationProvider,
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formBox {
	height: content;
	padding: 1.5em 2.5em;
	border-top: 0px solid #e8e8e8;
	border-left: 1px solid #e8e8e8;
	border-right: 1px solid #e8e8e8;
	border-bottom: 1px solid #e8e8e8;
	box-shadow: -4px 4px 10px 0 rgba(0, 0, 0, 0.2);
}

.formTitle {
	font-size: 1.6em;
	padding-bottom: 6px;
	margin-bottom: 15px;
	border-bottom: 1.5px solid #e8e8e8;
}

.formHeader {
	font-size: 16px;
	margin-bottom: 2px;
}

.formInput {
	width: 70%;
	height: 30px;
	font-size: 16px;
	padding-left: 6px;
}

.formInput:not(:last-child) {
	margin-bottom: 15px;
}

input[type='submit'] {
	display: block;
	-webkit-appearance: button;
	font-size: 15px;
	width: 135px;
	height: 36px;
	margin-left: 277px;
	background-color: #e18988;
	color: #ffffff;
	border: none;
	border-radius: 3px;
}

/* Forces .form-input styles onto search type */
input[type='search'] {
	-webkit-appearance: textfield;
	box-sizing: content-box;
}
</style>
